<template>
  <div>
    <div class="home-container">
      <list v-model="isLoading"
            :finished="dataLoadingFinished"
            loading-text=" "
            finished-text="到底了"
            @load="initItemFeed"
      >
        <mix-item-list :data="dataList"></mix-item-list>
      </list>
      <Empty v-if="dataLoadingFinished && !totalCount"></Empty>
    </div>
  </div>
</template>

<script>
  import {List, Empty} from "vant"
  import MixItemList from "@/components/ugc_item/MixItemList";

  export default {
    name: "MixItemFeed",
    components: {
      MixItemList, List, Empty
    },
    props: {
      listType: {},
    },
    data() {
      return {
        currentPage: 0,
        maxCursor: 0,
        totalCount: 0,
        countPerPage: 0,
        offset: 0,

        showLogin: false,
        isLoading: false,
        dataLoadingFinished: false,

        dataList: [],
      };
    },
    mounted() {
      this.initParams()
    },
    methods: {
      initParams() {
        // let curPage = this.$route.query.page
        // if (curPage) {
        //   this.currentPage = parseInt(curPage)
        // } else {
        this.currentPage = 0
        // }
        this.offset = 0
        this.dataList = []
        this.dataLoadingFinished = false
        this.showLogin = false
      },

      createToast(text, type) {
        if (!type) {
          type = "text"
        }
        const toast = this.$createToast({
          time: 1500,
          txt: text,
          type: type,
        })
        toast.show()
      },

      async initItemFeed() {
        this.isLoading = true
        let params = {
          page: this.currentPage,
          offset: this.offset,
          list_type: this.listType,
        }
        await this.$store.dispatch("GetFeedItemList", params).then((result) => {
          if (result.code === 0) {
            this.dataList.push(...result.data);
            let extra = result.extra
            this.totalCount = extra.total_count
            this.countPerPage = extra.count_per_page
            this.offset = extra.max_cursor  // 下一次请求的 offset
            this.dataLoadingFinished = !extra.has_more
          } else if (result.code === 20010) {
            this.showLogin = true
            this.dataList = []
            this.totalCount = 0
            this.dataLoadingFinished = true
          } else {
            this.createToast("请求错误")
            this.dataLoadingFinished = true
          }
        }, () => {
          this.createToast("网络异常", "error")
          this.dataLoadingFinished = true
        });
        this.isLoading = false
      },

      onChange() {
        // let params = {
        //   page: this.currentPage,
        //   list_type: this.listType,
        // }
        // this.$router.push({query: params})
        this.initParams()
        this.initItemFeed()
      },

      onLoginSuccess() {
        window.location.reload()
      }
    },
    computed: {},
    watch: {
      listType() {
        this.onChange()
      },
    }
  };
</script>

<style scoped>
  .home-container {
    position: relative;
  }
</style>
